import { BaseContainerModel } from "../base-container.model";
import { bl_wms_warehouse_hdr_RowInterface, bl_wms_warehouse_hdr_RowClass } from "../../dbschema/index";

export class WarehouseContainerModel extends BaseContainerModel {
  bl_wms_warehouse_hdr: bl_wms_warehouse_hdr_RowInterface = new bl_wms_warehouse_hdr_RowClass();
}
